import {shuffle} from 'lodash';

export const shuffleForSure = <T>(array: Array<T> | ReadonlyArray<T>): Array<T> => {
  let shuffled = [...array];
  do {
    shuffled = shuffle(shuffled);
  } while (JSON.stringify(array) === JSON.stringify(shuffled));

  return shuffled;
};
